<section class="bg-white py-20 md:py-24">
  <div class="mx-auto max-w-7xl px-4 sm:px-5 md:px-0">
    <div class="mx-auto max-w-4xl text-center">
      <p class="text-sm font-semibold uppercase tracking-[0.2em] text-blue-700 font-['Inter']">Como funciona</p>
      <h2 class="mt-4 text-center text-gray-900 text-4xl font-extrabold font-['Inter'] leading-tight">
        Da busca à decisão em três passos
      </h2>
    </div>

    <div class="mt-14 grid grid-cols-1 gap-8 lg:grid-cols-3">
      @for (step of steps; track step.title) {
        <article class="rounded-md bg-white p-6 shadow-[0px_1px_2px_-1px_rgba(0,0,0,0.10)] shadow-[0px_1px_3px_0px_rgba(0,0,0,0.10)] outline outline-1 outline-offset-[-1px] outline-gray-100">
          <p class="text-sm font-semibold uppercase tracking-[0.16em] text-blue-700 font-['Inter']">{{ step.step }}</p>
          <h3 class="mt-4 text-xl font-bold leading-tight text-gray-900 font-['Inter']">{{ step.title }}</h3>
          <p class="mt-3 text-base font-normal leading-relaxed text-gray-500 font-['Inter']">{{ step.description }}</p>
        </article>
      }
    </div>
  </div>
</section>
